// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__3cpaj","header":"ErrorPage_header__Cb201","text":"ErrorPage_text__QOKQc"};